import Entity from './entity'
export default class EmailSetting extends Entity<number>{
    name:string;
    isActive:boolean;
  
}